import React, { Component } from 'react';
import SeriesTitle from 'react/views/series/SeriesTitle';
import MeasuredCarouselView from 'react/views/carousel/MeasuredCarouselView';
import ResultsModal from "../generic/ResultsModal";
import ResultsHeader from "../generic/ResultsHeader";
import TrackedLink from '../generic/TrackedLink';
import StoryMixerAdditionalInfo from './StoryMixerAdditionalInfo';
import StoryElementEventTypes from 'data/types/StoryElementEventTypes';

export const learnMoreAboutURL = "http://www.ebscohost.com/novelist/our-products/novelist-appeals";

class StoryMixerResultsView extends Component {
	constructor(props) {
		super(props);

		this.state = {
			modalSrc: "",
			isLoading: false,
			isModalOpen: false,
			iFrameStyle: { visibility: "hidden" }
		};

		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.dataLoaded = this.dataLoaded.bind(this);
	}

	renderBooks() {
		const seriesTitles = this.props.resultData.titles.map((title) => {
			return (
				//todo: rename SeriesTitle to TitleView in a separate pull request
				<SeriesTitle 
					key={title.uniqueId} 
					title={title} 
					jacketClickEvent={StoryElementEventTypes.STORYELEMENTS_COVER_CLICKED}
					titleClickEvent={StoryElementEventTypes.STORYELEMENTS_TITLE_CLICKED}
					otsFindItEvent={StoryElementEventTypes.STORYELEMENTS_FINDIT_CLICKED}
					otsClickEvent={StoryElementEventTypes.STORYELEMENTS_AVAILABILITY_CLICKED}
					otsEnabled={this.props.otsEnabled}
				/>
			);
		});
		return seriesTitles;
	}

	renderFooter() {
		return (
			<div>
				<TrackedLink featureType={StoryElementEventTypes.STORYELEMENTS_LEARNMORE_CLICKED} destId=''>
					<span onClick={this.openModal}>
						<a href="javascript:void(0)">Learn more about story elements</a>
					</span>
				</TrackedLink>
				<ResultsModal
					isLoading={false}
					isOpen={this.state.isModalOpen}
					close={this.closeModal}
					isScrollable={true}
				>
					<StoryMixerAdditionalInfo />
				</ResultsModal>
			</div>
		);
	}

	openModal() {
		this.setState({
			isModalOpen: true,
			isLoading: true,
			iFrameStyle: { visibility: "hidden" }
		});
	}

	closeModal() {
		this.setState({
			isModalOpen: false,
			isLoading: false,
			iFrameStyle: { visibility: "hidden" }
		});
	}

	dataLoaded() {
		this.setState({
			isLoading: false,
			iFrameStyle: { visibility: "visible" }
		});
	}

	renderHeader() {
		return (
			<ResultsHeader headerText={'BASED ON YOUR PICKS'} headerSummary={this.props.resultData.summary} resultData={this.props.resultData.titles} />
		);
	}

	render() {
		return (
			<MeasuredCarouselView
				header={this.renderHeader()}
				items={this.renderBooks()}
				footer={this.renderFooter()}
			/>
		);
	}
}

export default StoryMixerResultsView;



// WEBPACK FOOTER //
// ./src/react/views/storyMixer/StoryMixerResultsView.jsx